import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Martín', 'Nicolás', 'Sebastián', 'Facundo', 'Tomás', 'Agustín', 'Matías', 'Gonzalo', 'Leandro', 'Santiago', 'Franco', 'Joaquín', 'Ramiro', 'Federico', 'Luciano'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Then every 15-20 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 5000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-346">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 bg-darker border border-gold/30 p-4 rounded-md shadow-[0_0_20px_rgba(34,197,94,0.15)] max-w-sm flex items-center gap-3" data-id="element-347">
          <div className="bg-gold/20 p-2 rounded-full" data-id="element-348">
            <span className="text-xl" data-id="element-349">🔥</span>
          </div>
          <p className="text-sm text-gray-300 font-medium m-0 leading-tight" data-id="element-350">
            <span className="text-white font-bold" data-id="element-351">{currentName}</span> de{' '}
            {currentCity} acaba de comprar el{' '}
            <span className="text-gold" data-id="element-352">Sistema Megakit</span>
          </p>
        </motion.div>}
    </AnimatePresence>;
}